import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TestBasicInfo, TestData, TestTemplate } from '../models/test.models';
import { Observable } from 'rxjs';
import { EnvironmentService } from './environment.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TestService {
  constructor(private http: HttpClient, private environmentService: EnvironmentService) {}

  getTestData(): Observable<TestData> {
    return this.http.get<TestData>(`${this.environmentService.apiUrl}/test`);
  }

  getTestBasicInfo(testId: string): Observable<TestBasicInfo> {
    return this.http.get<{data: TestBasicInfo}>(`${this.environmentService.apiUrl}/createTest/getTestBasicInfo/${testId}`).pipe(
      map((data: any) => {
        return data.data;
      })
    );
  }

  getTemplateByTemplateId(templateId: string): Observable<TestTemplate> {
    return this.http.get<{data: TestTemplate}>(`${this.environmentService.apiUrl}/createTest/getTemplateByTemplateId/${templateId}`).pipe(
      map((data: any) => {
        return data.data;
      })
    );
  }

  viewTest(data: any): Observable<any> {
    return this.http.post<{data: any}>(`${this.environmentService.apiUrl}/startTest/viewTest`, data).pipe(
      map((data: any) => {
        return data.data;
      })
    );
  }

  updateCandidateImage(data: any): Observable<any> {
    return this.http.put<{data: any}>(`${this.environmentService.apiUrl}/startTest/updateCandidateImage`, data).pipe(
      map((data: any) => {
        return data.data;
      })
    );
  }

  updateIdVerificationSessionId(testId: string, sessionId: any) {
    return this.http.get(`${this.environmentService.apiUrl}/createTest/updateIdVerificationSessionId/${sessionId}/${testId}`);
  }

  addFeedback(data:any){
    return this.http.post(`${this.environmentService.apiUrl}/UserFeedback/addFeedback`, data);
  }
} 